import React from 'react';
import type { ColDef, EditableCallbackParams } from 'ag-grid-community';
import { LopCrudPage } from '../../components/LopCrudPage';
import {
  getLendingFeeCalcTypes,
  saveLendingFeeCalcTypesBatch,
} from '../../api/lendingFeeCalcTypes';
import type { LendingFeeCalcType } from '../../types/LendingFeeCalcType';
import { t } from '../../i18n/t';

const lendingFeeCalcTypesColumnDefs: ColDef<LendingFeeCalcType>[] = [
  {
    field: 'lendingFeeCalcTypeId',
    headerName: t('lendingFeeCalcTypes.columns.lendingFeeCalcTypeId'),
    width: 140,
    // Natural PK: editable on Add only; existing rows must keep their code.
    editable: (params: EditableCallbackParams<LendingFeeCalcType>) =>
      (params.data as { __status?: string } | undefined)?.__status === 'added',
    cellDataType: 'number',
    sort: 'asc',
  },
  {
    field: 'lendingFeeCalcTypeName',
    headerName: t('lendingFeeCalcTypes.columns.lendingFeeCalcTypeName'),
    flex: 1,
    editable: true,
  },
  {
    field: 'comment',
    headerName: t('lendingFeeCalcTypes.columns.comment'),
    flex: 1,
    editable: true,
  },
];

const newLendingFeeCalcTypeDefaults = (): Partial<LendingFeeCalcType> => ({
  lendingFeeCalcTypeId: 0,
  lendingFeeCalcTypeName: '',
  comment: null,
});

export function LendingFeeCalcTypesPage() {
  return (
    <LopCrudPage<LendingFeeCalcType>
      resourceCode="lendingFeeCalcTypes"
      titleKey="lendingFeeCalcTypes.pageTitle"
      idField="lendingFeeCalcTypeId"
      getRows={getLendingFeeCalcTypes}
      saveBatch={(added, modified, deletedIds) =>
        saveLendingFeeCalcTypesBatch(added, modified, deletedIds as number[])
      }
      columnDefs={lendingFeeCalcTypesColumnDefs}
      newRowDefaults={newLendingFeeCalcTypeDefaults}
    />
  );
}
